



















import { Component, Vue } from 'vue-property-decorator';
import { mapFields } from 'vuex-map-fields';

import ApiRoutes from '@/logic/ApiRoutes.ts';

import AllDisplayItemsList from '@/components/display-items/AllDisplayItemsList.vue';
import StickyDisplayItemList from '@/components/display-items/StickyDisplayItemList.vue';
import ProfileNotAvailableDialog from '@/components/dialogs/ProfileNotAvailableDialog.vue';
import ApiHandler from '@/logic/ApiHandler';
import GlobalEvents from '@/logic/GlobalEvents';
import LanguageHandler from '@/localisation/LanguageHandler';
import PullRefresh from '@/components/functional/PullRefresh.vue';

/**
 * Performance view, shows display items in one of four ways
 */
@Component({
    components: {
        AllDisplayItemsList,
        StickyDisplayItemList,
        ProfileNotAvailableDialog,
        PullRefresh
    },
    props: {
        // Optional, id of the performance to open
        // If given, a performance can be loaded directly
        linkid: {
            type: String
        },
        // Should be provided together with linkid
        // Code used to log into host
        hostlogin: {
            type: String
        }
    },
    computed: {
        ...mapFields('settings', [
            'performance_display_type',
            'order_top_first'
        ]),
    },
})
export default class Performance extends Vue {

    private profileUnavailable: boolean = false;

    private mounted() {

        GlobalEvents.$emit('enter-performance');

        // Load specified performance if coming from direct link
        if (this.$props.linkid) {
            const performanceId: number = parseInt(this.$props.linkid, 10);
            const loginPin: number = parseInt(this.$props.hostlogin, 10);

            this.$store.dispatch('settings/setPerformance', performanceId);
            this.testPin(loginPin);
        }

        // Attach listener for pull-refresh
        GlobalEvents.$on('local-refresh', () => {
            this.refresh()
                .then(() => GlobalEvents.$emit('local-refresh-done'));
        });

        this.$store.dispatch('performance/fetchDisplayItems');
        this.checkProfileAvailable();
    }

    private beforeDestroy() {
        // Detach global listeners
        GlobalEvents.$off('local-refresh');
    }

    private async refresh() {
        await this.$store.dispatch('performance/fetchDisplayItems');
    }

    // Check that the currently selected profile is available for this performance
    // If not select the first option
    private async checkProfileAvailable() {
        const performance = this.$store.getters['settings/getPerformance'];

        const request = ApiRoutes.getProfilesRequest(performance);
        const profiles = await ApiHandler.request(request);

        // Get list of profile ids
        const availableProfiles: number[] = [];
        profiles.forEach((profile: any) => {
            availableProfiles.push(parseInt(profile.profile_id, 10));
        });

        // Ensure an available profile is selected
        const profileId = this.$store.getters['settings/getProfile'];
        if (availableProfiles.length > 0 && !(availableProfiles.includes(profileId))) {

            this.profileUnavailable = true;

            // See if matching language is available
            const localeMatch = profiles.find(
                (profile) => LanguageHandler.getLocalisationCode(profile.language_id) === this.$store.getters['settings/getLocale']);
            if (localeMatch) {
                this.$store.dispatch('settings/setProfile', localeMatch.profile_id);
            } else {

                // Set profile to first available
                this.$store.dispatch('settings/setProfile', availableProfiles[0]);
            }

            // Refetch content
            this.$store.dispatch('performance/fetchDisplayItems');
        }
    }

    // Test the provided pin code for direct link
    private async testPin(pin: number) {

        const response = await ApiHandler.request(ApiRoutes.getLoginRequest(pin), true);

        if (response.length <= 0) {
            // Login failed, send user to home screen
            // TODO: implement failure notification toast
            this.$router.push('/');
        } else {
            const data = JSON.parse(response);
            this.$store.dispatch('settings/setHost', data);
        }
    }
}
